import axios from "axios";
import {
  AddIdentifier,
  AddIdentifierVerification,
} from "../../Models/Request/Identifier/AddIdentifier";

export function getIdentifiers() {
  return axios.get(`/User/Identifiers`);
}

export function addIdentifier(body: AddIdentifier) {
  return axios.post(`/User/Identifiers`, body);
}

export function addIdentifierVerification(body: AddIdentifierVerification) {
  return axios.post(`/User/Identifiers/Verify`, body);
}
